import { createTheme } from '@mui/material/styles';
import { Components } from '@mui/material/styles/components';
import { ControllerSnackbarColor } from '../../palette';

const theme = createTheme();

export const SnackbarComponent: Components = {
  MuiSnackbar: {
    styleOverrides: {
      root: {
        left: theme.spacing(6),

        '& .MuiIconButton-label': {
          color: String(ControllerSnackbarColor.DefaultFg),
        },
      },
    },
  },
};
